import React, { useEffect, useState, useMemo } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import './rightSidebar.css';
import './index.css'
import { SocialProofLogo as LogoCompanies } from './logoCompanies/LogoCompanies';
import PropTypes from 'prop-types';
import nextIcon from '../../assets/img/social-proof-next.svg';
import prevIcon from '../../assets/img/social-proof-prev.svg';
import TCLogo from '../../assets/img/TC.svg';
import InformationLogo from '../../assets/img/Information.svg';
import EntrepreneurLogo from '../../assets/img/Entrepreneur.svg';
import ForbesLogo from '../../assets/img/Forbes.svg';
import FastoCompanyLogo from '../../assets/img/FastoCompany.svg';
import { FETCH_CLIENT_INFORMATION_BY_IP } from './action';
import getDeveloperTestimonial from '../../legacy_components/util/getDeveloperTestimonial';
import { countryFlags } from '../ClientInformation/quotes';

function NextArrow(props) {
  const { style, onClick } = props;
  return (
    <div
      className='social-proof-slider-next'
      style={{ ...style, display: "block" }}
      onClick={onClick}
    ><img src={nextIcon} width={6} height={11} /></div>
  );
}

function PrevArrow(props) {
  const { style, onClick } = props;
  return (
    <div
      onClick={onClick}
      className='social-proof-slider-prev'
      style={{ ...style, display: "block" }}
    ><img src={prevIcon} width={6} height={11} /></div>
  );
}

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [{
    breakpoint: 1024,
    settings: "unslick" // destroys slick

  }]
};


const DefaultComponent = React.memo(() => {
  const [countryName, setCountryName] = useState(null);
  const [totalHiredDeveloper, setTotalHired] = useState(null);
  const [isCountryTotal, setIsCountryTotal] = useState(false);

  const FetchInfo = async () => {
    const data = await FETCH_CLIENT_INFORMATION_BY_IP();
    if (data) {
      setCountryName(data.countryName);
      setTotalHired(data.totalHiredDeveloper);
      setIsCountryTotal(data.isTotalInCountry)
    }
  }

  

  useEffect(() => {
    FetchInfo()
  }, []);

  const testimonialForCountry = useMemo(() => getDeveloperTestimonial(countryName), [countryName])
  

  return (
    <div className="sidebar-container default-sidebar centered-ctn social-proof">
      <div className='flex-top' />
      <div className='social-proof-content'>
        { countryName && totalHiredDeveloper ? (
            <Slider {...settings}>
            <CompaniesLogo />
            <DevelopersHired totalHiredDeveloper={totalHiredDeveloper} countryName={countryName} isCountryTotal={isCountryTotal} />
            {
              testimonialForCountry && testimonialForCountry.length ? (
                testimonialForCountry.map((dev, index) => (
                  <TestimonialComponent developer={dev} key={`${testimonialForCountry.country}-${index}`} />
                ))
              ) : null
            }
            <OtherCompanyLogo />
          </Slider>
        ) : (
          <Slider {...settings}>
            <CompaniesLogo />
            <OtherCompanyLogo />
          </Slider>

        )}
      </div>
    </div>
  );
});

const CompaniesLogo = () => (
  <div>
    <div className="turing-text social-proof-title">Work remotely with top <br/>US companies</div>
    <LogoCompanies />
  </div>
);

const DevelopersHired = ({ totalHiredDeveloper, countryName, isCountryTotal }) => (
  <div className='total-developers-hired'>
    <div>We’ve found jobs for</div>
    <div className='total-hired-number'>{`${totalHiredDeveloper}+`}</div>
    {isCountryTotal ? 
      <div>developers from {countryName} <img className='country-flag-logo' src={countryFlags[countryName.toLowerCase()]} alt='🌍' width="20px" height="20px" /> so far and you could be the next one!</div>
      : <div>developers from around the World 🌍 so far and you could be the next one!</div>
    }
  </div>
)

const TestimonialComponent = ({developer}) => {
  return (
    <div className='dev-testimonial'>
      <div className='dev-testimonial-quote'>&quot;{developer.quote}&quot;</div>
      <div className='developer-testimonial-info'>
        <img className='dev-testimonial-img' src={developer.url} alt={`${developer.name} picture`} />
        <div className='developer-info'>
          <div className='developer-name'>{developer.name}</div>
          {developer.role ? <div>{developer.role}</div> : null}
          <div className='developer-country'><span>{developer.country}</span> <span><img src={countryFlags[developer.country.toLowerCase()]} alt='icon' width="20px" height="20px" /></span></div>
        </div>
      </div>
    </div>
  )
}

const OtherCompanyLogo = () => (
  <div className="as-seen-on-social-proof">
    <p className="as-seen-on-title">As seen on</p>
    <div className="logo-row">
      <img className="company-logo logo-1" src={TCLogo} alt="TC" width="55px" height="27px" />
      <img className="company-logo logo-2" src={InformationLogo} alt="Information" />
    </div>
    <div className="logo-row">
      <img className="company-logo logo-3" src={EntrepreneurLogo} alt="Entrepreneur" />
      <img className="company-logo forbes-logo" src={ForbesLogo} alt="Forbes" />
    </div>
    <div className='logo-row'>
    <img className="company-logo logo-4" src={FastoCompanyLogo} alt="FastoCompany" />
    </div>
  </div>
)

DefaultComponent.propTypes = {
  isOnboardingDefault: PropTypes.bool
};

export default DefaultComponent;
